<div class="mt-0 pt-0 ms-1 me-1" style="background-color: #FBFBFB !important;">
    <header>
        <!-- <div class="text-center mt-3">
            <img src="assets/images/logo-checkout.png" alt="Image" style="width: 7.776rem;" />
        </div> -->
        <h1 class="main-text checkout-title text-center pt-3">Términos y Condiciones de Uso de RiverApp</h1>
    </header>
    <main class="container">
        <section>
            <p>Bienvenido a RiverApp (en adelante, "la App"), un marketplace donde los usuarios pueden comprar
                y vender
                productos. Al acceder y utilizar la App, aceptas estos términos y condiciones. Si no estás de acuerdo
                con
                estos términos, te pedimos que no utilices la App.</p>
        </section>
        <section class="mt-4">
            <h2 class="mt-3 font-size-terms">1. Definiciones</h2>
            <ul>
                <li><strong>Usuario:</strong> Cualquier persona que acceda y utilice la App, ya sea como comprador o
                    vendedor.</li>
                <li><strong>Vendedor:</strong> Usuario que ofrece productos a la venta en la App.</li>
                <li><strong>Comprador:</strong> Usuario que adquiere productos a través de la App.</li>
                <li><strong>Servicios:</strong> Incluyen la posibilidad de publicar productos, realizar compras y
                    realizar
                    pagos a través de la App.</li>
            </ul>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">2. Edad Mínima</h2>
            <p class="ms-5">El uso de RiverApp está restringido a usuarios mayores de 18 años. Al registrarte, declaras
                ser
                mayor de edad
                y contar con capacidad legal para aceptar estos términos.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">3. Registro de Usuario</h2>
            <p class="ms-5">Para acceder a los servicios, los usuarios deben registrarse proporcionando información
                personal, incluyendo:
            </p>
            <div class="ms-5 mt-3">
                <h3 class="font-size-terms">Para Compradores:</h3>
                <ul>
                    <li>Nombre completo</li>
                    <li>Número de teléfono</li>
                    <li>Dirección</li>
                    <li>Contraseña</li>
                </ul>
                <h3 class="font-size-terms">Para Vendedores:</h3>
                <ul>
                    <li>Nombre completo del administrador de la tienda</li>
                    <li>Nombre de la tienda</li>
                    <li>Descripción de la tienda</li>
                    <li>Departamento y ciudad</li>
                    <li>Dirección</li>
                    <li>Teléfono de contacto</li>
                    <li>Correo electrónico</li>
                    <li>Contraseña</li>
                    <li>Logo</li>
                </ul>
            </div>
            <p>El usuario es responsable de mantener la exactitud y actualización de esta información. El uso de la App
                está
                sujeto a la verificación de los datos proporcionados.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">4. Recopilación y Uso de Datos</h2>
            <p class="ms-5">Para información sobre cómo recopilamos, utilizamos y protegemos tus datos personales,
                consulta
                nuestra <a href="#">Política de Tratamiento de Datos</a>.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">5. Política de Tratamiento de Datos</h2>
            <p class="ms-5">Para conocer todos los detalles sobre el manejo de tus datos personales, incluyendo cómo los
                recopilamos,
                utilizamos, protegemos y compartimos, consulta nuestra <a href="#">Política de Tratamiento de Datos</a>.
            </p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">6. Pagos y Pasarela de Pago</h2>
            <p class="ms-5">RiverApp utiliza Wompi como pasarela de pago para procesar transacciones de manera segura.
                Al
                realizar una
                compra, el usuario acepta las condiciones de servicio de Wompi. Para más detalles sobre el manejo de
                datos
                relacionados con pagos, consulta nuestra <a href="#">Política de Tratamiento de Datos</a>.</p>
            <p class="ms-5">Para mayor información sobre Wompi, consulta su <a href="https://wompi.co/">política de
                    privacidad</a>.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">7. Responsabilidades del Usuario</h2>
            <div class="ms-5 mt-3">
                <h3 class="font-size-terms">Vendedores:</h3>
                <p class="ms-5">Deben garantizar la calidad, descripción precisa y entrega oportuna de los productos
                    ofrecidos.
                </p>
                <h3 class="font-size-terms">Compradores:</h3>
                <p class="ms-5">Son responsables de proporcionar información precisa para la compra y el envío.</p>
            </div>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">8. Prohibiciones</h2>
            <ul>
                <li>Publicar productos que infrinjan derechos de propiedad intelectual, sean fraudulentos o ilegales.
                </li>
                <li>Usar la App para fines distintos a los establecidos en estos términos.</li>
                <li>Realizar actividades que comprometan la seguridad de la App.</li>
            </ul>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">9. Propiedad Intelectual</h2>
            <p class="ms-5">Todos los contenidos de RiverApp, incluidos textos, imágenes, logos y gráficos, son
                propiedad de
                la App o
                están licenciados para su uso. Queda prohibida su reproducción sin autorización previa.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">10. Limitación de Responsabilidad</h2>
            <p>RiverApp no se hace responsable de:</p>
            <ul>
                <li>Los productos vendidos ni de las transacciones realizadas entre usuarios.</li>
                <li>Daños directos o indirectos derivados del uso de la App.</li>
            </ul>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">11. Contacto</h2>
            <p>Si tienes preguntas o inquietudes, puedes contactarnos a través de:</p>
            <ul>
                <li><strong>Correo electrónico:</strong> <a
                        href="mailto:riverappoficial@gmail.com">riverappoficial&#64;gmail.com</a></li>
                <li><strong>Teléfono:</strong> +57 301 9854097</li>
            </ul>
            <p>Este documento está sujeto a modificaciones. Te recomendamos revisarlo periódicamente para estar al tanto
                de
                los cambios.</p>
        </section>
    </main>

    <footer class="text-center">
        <p class="ms-5">&copy; 2025 RiverApp. Todos los derechos reservados.</p>
    </footer>
</div>